/* 筛选按钮<el-popover
  placement="bottom"
  width="300"
  v-model="popoverVisible">
  <el-checkbox-group v-model="propList">
    <el-checkbox :label="item" v-for="(item, index) in allPropList" :key="index" style="width: 120px">{{item.label}}</el-checkbox>
  </el-checkbox-group>
  <el-button slot="reference" size="small" style="float: right;">筛选</el-button>
</el-popover> */

/* 循环列<el-table-column
  :label="item.label"
  :prop="item.prop"
  :min-width="item.width"
  :sortable="item.sortable ? 'custom' : false"
  show-overflow-tooltip
  v-for="item in sortedPropList" :key="item.prop"
>
  <template slot-scope="scope">
    <template>
      {{scope.row[item.prop]}}
    </template>
  </template>
</el-table-column> */

// 导出
// const loading = this.$loading({
//   lock: true,
//   text: 'Loading',
//   spinner: 'el-icon-loading',
//   background: 'rgba(0, 0, 0, 0.7)'
// });
// let params = {
//   taskDTO: {
//     appCode: "ec-pc-api",
//     // 数据过滤
//     paramMap: {
//       exportTag: true,
//       ...this.searchForm.filterData
//     },
//     reportName: "skuExport"
//   },
//   // 配置导出列
//   columnDTOs: [
//     // {
//     //   columnName: '包件编码',
//     //   parentColumnName: null,
//     //   fieldName: 'packCode',
//     //   fieldType: 'string',
//     //   columnFormat: null
//     // }
//   ]
// };
// let labels = this.sortedPropList.map(v=>v.label);
// let props = this.sortedPropList.map(v=>v.prop);
// props.forEach((prop, index) => {
//   params.columnDTOs.push({
//     columnName: labels[index],
//     parentColumnName: null,
//     fieldName: prop,
//     fieldType: 'string',
//     columnFormat: null
//   })
// })
// // 不导出图片列
// params.columnDTOs = params.columnDTOs.filter(v=>v.columnName !== '图片');
// this.$q.common.customExportExcel({data: params}).then((res) => {
//   console.log(res)
//   loading.close();
//   this.$message({
//     type: "success",
//     message: "导出成功,请在导出列表中查看",
//   });
// });
export default {
  data() {
    return {
      checkAll: true,
      popoverVisible: false,
      propList: [], //列展示状态
      propListTwo: [], //多选框状态
      columnData: [],
    }
  },
  computed: {
    allPropList() {
      let propsConf = [
        // 大型号品类分布 
        [
          { label: '品类', prop: 'category', width: '150px', sortable: false, span: false, fixed: false, },
          { label: '引流款(A)', prop: 'drainageModel', width: '150px', sortable: 'custom', span: false, fixed: false, },
          { label: '主推款(B)', prop: 'mainPushModel', width: '150px', sortable: 'custom', span: false, fixed: false, },
          { label: '次推款(C)', prop: 'nextPushModel', width: '150px', sortable: 'custom', span: false, fixed: false, },
          { label: '常规款(D)', prop: 'regularModel', width: '150px', sortable: 'custom', span: false, fixed: false, },
          { label: '形象款', prop: 'imageModel', width: '150px', sortable: 'custom', span: false, fixed: false, },
          { label: '滞销款(E)', prop: 'slowPaymentModel', width: '150px', sortable: 'custom', span: false, fixed: false, },
          { label: '合计', prop: 'total', width: '150px', sortable: 'custom', span: false, fixed: false, },
        ],
        // 价格段分布
        [
          { label: '品类', prop: 'category', width: '100px', sortable: false, span: false, fixed: false, },
          { label: '销售等级', prop: 'typeName', width: '100px', sortable: 'custom', span: false, fixed: false, },
          { label: '销售等级上升', prop: 'saleLocationUp', width: '120px', sortable: 'custom', span: false, fixed: false, },
          { label: '销售等级下降数量', prop: 'saleLocationDown', width: '130px', sortable: 'custom', span: false, fixed: false, },
          { label: '销售等级不变数量', prop: 'productTypeUnChange', width: '80px', sortable: 'custom', span: false, fixed: false, },
          
        ],
        // 大型号产品类别概览
        [
          { label: '品类', prop: 'category', width: '150px', sortable: false, span: false, fixed: false,},
          { label: '产品类别', prop: 'productType', width: '80px', sortable: 'custom', span: false, fixed: false,},
          { label: '销售等级上升', prop: 'saleLocationUp', width: '150px', sortable: 'custom', span: false, fixed: false, },
          { label: '销售等级下降数量', prop: 'saleLocationDown', width: '150px', sortable: 'custom', span: false, fixed: false, },
          { label: '销售等级不变数量', prop: 'productTypeUnChange', width: '150px', sortable: 'custom', span: false, fixed: false, },
          { label: '滞销款数量', prop: 'slowPaymentModelNum', width: '150px', sortable: 'custom', span: false, fixed: false, },
        ],
        // 月均销售数量段分布
        [
          { label: '品类', prop: 'category', width: '150px', sortable: false, span: false, fixed: false, },
          { label: '产品类别', prop: 'typeName', width: '80px', sortable: 'custom', span: false, fixed: false, },
          { label: '非滞销款数量', prop: 'notUnsoldStyle', width: '150px', sortable: 'custom', span: false, fixed: false, },
          { label: '滞销款数量', prop: 'unsoldStyle', width: '150px', sortable: 'custom', span: false, fixed: false, },
          { label: '合计', prop: 'total', width: '150px', sortable: 'custom', span: false, fixed: false, },
        ],
      ]
      // 列排序，避免列错乱显示。
      propsConf[this.activeTable].forEach((e,i)=>{
        e['sort'] = i;
      })
      return propsConf[this.activeTable];
    },
    // 将筛选显示的列重新按照原始排序重新排列
    sortedPropList() {
      if(this.activeTable == 0 && this.formData.productType) {
        this.propList = [
          { label: '品类', prop: 'category', width: '150px', sortable: false, span: false, fixed: false, },
          { label: '引流款(A)', prop: 'drainageModel', width: '150px', sortable: 'custom', span: false, fixed: false, },
          { label: '主推款(B)', prop: 'mainPushModel', width: '150px', sortable: 'custom', span: false, fixed: false, },
          { label: '次推款(C)', prop: 'nextPushModel', width: '150px', sortable: 'custom', span: false, fixed: false, },
          { label: '常规款(D)', prop: 'regularModel', width: '150px', sortable: 'custom', span: false, fixed: false, },
          { label: '滞销款(E)', prop: 'slowPaymentModel', width: '150px', sortable: 'custom', span: false, fixed: false, },
          { label: '合计', prop: 'total', width: '150px', sortable: 'custom', span: false, fixed: false, },
        ]
      }else if(this.activeTable == 0 && !this.formData.productType) {
       this.propList = [
          { label: '品类', prop: 'category', width: '150px', sortable: false, span: false, fixed: false, },
          { label: '引流款(A)', prop: 'drainageModel', width: '150px', sortable: 'custom', span: false, fixed: false, },
          { label: '主推款(B)', prop: 'mainPushModel', width: '150px', sortable: 'custom', span: false, fixed: false, },
          { label: '次推款(C)', prop: 'nextPushModel', width: '150px', sortable: 'custom', span: false, fixed: false, },
          { label: '常规款(D)', prop: 'regularModel', width: '150px', sortable: 'custom', span: false, fixed: false, },
          { label: '形象款', prop: 'imageModel', width: '150px', sortable: 'custom', span: false, fixed: false, },
          { label: '滞销款(E)', prop: 'slowPaymentModel', width: '150px', sortable: 'custom', span: false, fixed: false, },
          { label: '合计', prop: 'total', width: '150px', sortable: 'custom', span: false, fixed: false, },
        ]
      }
      return this.propList.sort((a,b)=> {
        return a['sort'] - b['sort']
      })
    },

  },
  mounted() {
    // 默认显示全部列
    this.propList = this.allPropList;
    this.propListTwo = this.allPropList;
    
  },
  methods: {
    
  }
}